import React, { useEffect, useState } from 'react'
import MUIDataTable from 'mui-datatables'

import { Container, Typography, Button } from 'src/modules/ui'
import EquipmentTypeModal from './EquipmentTypeFormModal'
import { useRecipes } from '../../hooks'
import { useActionRunner } from '../../../../../notification'

const EquipmentTypeListView = ({ title = 'Equipment Types' }) => {
  const [editEquipmentType, setEditEquipmentType] = useState(null)

  const { fetchEquipmentTypes, equipmentTypes, isLoading } = useRecipes()
  const [doFetchEquipmentTypes] = useActionRunner(fetchEquipmentTypes)

  useEffect(() => {
    doFetchEquipmentTypes()
  }, [])

  const columns = [
    {
      name: 'name',
      label: 'Equipment',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'pricePerUnit',
      label: '£/unit',
      options: {
        filter: true,
        sort: true,
        sortDirection: 'asc',
      },
    },
    {
      name: 'usagePerHour',
      label: 'usage/hour',
      options: {
        filter: true,
        sort: true,
        sortDirection: 'asc',
      },
    },
  ]

  const options = {
    download: false,
    elevation: 0,
    onRowClick: (row, { dataIndex }) => {
      setEditEquipmentType(equipmentTypes[dataIndex])
    },
    print: false,
    responsive: 'simple',
    rowsPerPage: 20,
    rowsPerPageOptions: [20, 50, 100],
    selectableRows: false,
    viewColumns: false,
  }

  return (
    <>
      <Container muiTable>
        <EquipmentTypeModal
          editEquipmentType={editEquipmentType}
          trigger={props => (
            <Button
              color="lightGreen"
              style={{ marginTop: 20, marginBottom: 10 }}
              {...props}
            >
              Add Equipment Type
            </Button>
          )}
        />
        {isLoading ? (
          <Typography>Loading...</Typography>
        ) : (
          <MUIDataTable
            columns={columns}
            data={equipmentTypes}
            options={options}
            title={title}
          />
        )}
      </Container>
    </>
  )
}

export default EquipmentTypeListView
